 <template>
    <div v-if="!colla" class="max-w-screen-lg md:mx-auto p-6 text-center text-gray-600">
        No s'ha trobat la colla indicada.
    </div>
    <div v-else>
        <div class="w-full" :class="colles[mostra].color_hsl[2]>=50?'text-black':'text-white'" :style=" colles[mostra].codi_color!=='#ffffff'?{backgroundColor: colles[mostra].codi_color}:{backgroundColor:'#e0e0e0'}">
            <div class="max-w-screen-lg md:mx-auto py-4 flex items-center text-sm gap-x-2 mx-2 flex-wrap">
                <span class="hover:underline text-nowrap">
                    <router-link :to="'/'+colla.llista">{{formatLlista(colla.llista)}}, </router-link>
                </span>
                <span class="hover:underline text-nowrap">
                    <router-link :to="'/'+colla.llista+'?tipus='+colla.tipus">Colles {{Format(colla.tipus).plural}},</router-link>
                </span>
                <span class="hover:underline text-nowrap">
                    <router-link :to="'/colles?tipus='+colla.tipus+'&estat='+colla.estat">{{Format(colla.estat).plural}},</router-link>
                </span>
                <span class="hover:underlin text-nowrape">
                    <router-link :to="'/colles/'+colla.id" >{{ colla.nom }}</router-link></span></div>
            <div class="max-w-screen-lg mx-auto py-4 grid gap-4 grid-cols-12">
                <div class="col-span-12 md:col-span-3 flex items-center justify-center ">
                <div  class="max-w-48 w-full border-solid border-white border-4 flex items-center justify-center cursor-pointer block aspect-square"
                    
                    :style=" 
                        colles[mostra].patro?.length?{
                            backgroundColor: colles[mostra].codi_color,
                            backgroundImage: `url(${require('@/assets/patrons/' + colles[mostra].patro[0])})`,
                            backgroundPosition: `center`,
                            backgroundSize: `${colles[mostra].patro[1]}%`
                        }:
                        colles[mostra].codi_color!=='#ffffff'?{backgroundColor: colles[mostra].codi_color}:
            
                        {backgroundColor:'#e0e0e0'}">
                       <Vimg
                       class="w-full h-full"
                       :src="escut" 
                       :class="!colles[mostra].xy_escut?.length?
                       colles[mostra].color_hsl[2]>=50?'brightness-0 opacity-50':'opacity-50'
                       :''" 
                    :alt="!colles[mostra].xy_escut?.length?'Escut desconegut':`Escut de la colla ${colles[mostra].nom}`"
                />
                </div>
                </div>
               

                <div class="col-span-12 md:col-span-5 flex flex-col px-4 md:items-start items-center text-center md:text-left">
                    <h1 class="text-2xl font-bold inline-flex items-center"><span>{{ colles[mostra].nom }}
                        <span class="text-nowrap">
                            <IcoTipEst :colla="colles[mostra]" dada="tipus" class=""/>
                        <IcoTipEst :colla="colles[mostra]" dada="estat" class="ml-2"/>
                        </span></span>
                    </h1>
                    <div class="">
                    <h2 class="mb-1 opacity-80"><em v-for="(malnom,index) in colla.malnoms" :key="index">{{ malnom }}<span v-if="index<colla.malnoms.length-1">, </span> </em></h2>
                    <h2 class="">{{ colla.localitat }}</h2>
                    <h2>
                        <span class="text-nowrap hover:underline cursor-pointer" 
                        v-for="(subcolla,index) in colles" :key="index" 
                        @click="mostra=index">{{subcolla.fundacio +"-"}}<span v-if="subcolla.estat=='activa'||subcolla.estat=='formacio'">Actualitat</span>
                            <span v-else><span v-if="subcolla.desaparicio!==-1">{{ subcolla.desaparicio }}</span>
                            <span v-else>Desconegut</span></span>
                            <span v-if="index<colles.length-1">, </span>
                    </span>
                    </h2>
                  
                    
                    </div>
                        <p class="my-1 text-2xl icons gap-2 flex grow items-end">
                    <a class=" opacity-70 hover:opacity-100" 
                        title="Pàgina Web de la Colla" v-if="colla.web!==null" 
                        :href="'https://'+colla.web" 
                        target="_blank" alt="Pàgina Web de la Colla">
                            <font-awesome-icon :icon="['fas','globe']"/>
                    </a>
                    <a  v-if="colla.instagram!==null" 
                        title="Pàgina d'Instagram de la Colla"
                        alt="Pàgina d'Instagram de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.instagram.com/'+colla.instagram" target="_blank">
                        <font-awesome-icon :icon="['fab', 'instagram']"/>
                    </a>
                    <a  v-if="colla.twitter!==null" 
                        title="Pàgina de Twitter de la Colla"
                        alt="Pàgina de Twitter de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.x.com/'+colla.twitter" target="_blank">
                        <font-awesome-icon :icon="['fab', 'x-twitter']"/>
                    </a>
                    <a  v-if="colla.facebook!==null" 
                        title="Pàgina de Facebook de la Colla"
                        alt="Pàgina de Facebook de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.facebook.com/'+colla.facebook" target="_blank">
                        <font-awesome-icon :icon="['fab', 'facebook']"/>
                    </a>
                    <a  v-if="colla.youtube!==null" 
                        title="Pàgina de YouTube de la Colla"
                        alt="Pàgina de YouTube de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.youtube.com/@'+colla.youtube" target="_blank">
                        <font-awesome-icon :icon="['fab', 'youtube']"/>
                    </a>
                
                    <a title="Article Wikipedia de la Colla"
                        alt="Article Wikipedia de la Colla"
                        class="opacity-70 hover:opacity-100"
                        :href="colla.wikipedia!==null?'https://ca.wikipedia.org/w/index.php?title='+colla.wikipedia:'https://ca.wikipedia.org/w/index.php?title='+colla.nom+'&action=edit&redlink=1'" target="_blank">
                        <font-awesome-icon :icon="['fab', 'wikipedia-w']"/></a>
                </p>
            
                </div>
                <div class=" col-span-12 justify-center md:col-span-4 text-center self-center flex gap-3 p-2">
                    
                    <div role="tooltip" class=" aspect-square border-solid border-4 border-white size-16 md:size-24  flex items-center justify-center drop-shadow hover:drop-shadow-lg cursor-pointer"
                    :style=" 
                        colles[mostra].patro?.length?{
                            backgroundColor: colles[mostra].codi_color,
                            backgroundImage: `url(${require('@/assets/patrons/' + colles[mostra].patro[0])})`,
                            backgroundPosition: `center`,
                            backgroundSize: `${colles[mostra].patro[1]}%`
                        }:
                        colles[mostra].codi_color!=='#ffffff'?{backgroundColor: colles[mostra].codi_color}:
            
                        {backgroundColor:'#e0e0e0'}">
                    <span v-if="colles[mostra].codi_color=='#ffffff'" class="text-4xl md:text-6xl font-bold my-auto">?</span>
                    <!--<tippy to="parent" content-tag="div" placement="top" theme="light" content-class="rounded-sm"> 
                        <div class="p-2 justify-center">
                            <p class="py-1 font-bold text-base">{{ colles[mostra].color_camisa }}</p>
                            <p><span class="font-bold">PANTONE:</span> <span v-if="colles[mostra].pantone?.length">{{ colles[mostra].pantone }}</span><span v-else>No especificat</span></p>
                            <p><span class="font-bold">HEX:</span> {{ colles[mostra].codi_color }}</p>
                            <p><span class="font-bold">RGB:</span> {{ colles[mostra].color_rgb[0] }}, {{ colles[mostra].color_rgb[1] }}, {{ colles[mostra].color_rgb[2] }}</p>
                            <p><span class="font-bold">HSL:</span> {{ colles[mostra].color_hsl[0] }}, {{ colles[mostra].color_hsl[1] }}%, {{ colles[mostra].color_hsl[2] }}%</p>
                            <p><span class="font-bold">CMYK:</span></p>
                        </div>
                    </tippy>-->
                    </div>
                    <div class="text-left lg:text-nowrap text-sm w-[60vw]">
                        
                    <p class="font-bold text-base">{{ colles[mostra].color_camisa }}</p>
                    <ul class="opacity-80 flex md:flex-col flex-wrap gap-1">
                        <li class="flex-nowrap"><span class="font-bold">PANTONE:</span> <span v-if="colles[mostra].pantone?.length">{{ colles[mostra].pantone }}</span><span v-else>No especificat</span></li>
                        <li class="flex-nowrap"><span class="font-bold">HEX:</span> {{ colles[mostra].codi_color }}</li>
                        <li class="flex-nowrap"><span class="font-bold">RGB:</span> {{ colles[mostra].color_rgb[0] }}, {{ colles[mostra].color_rgb[1] }}, {{ colles[mostra].color_rgb[2] }}</li>
                        <li class="flex-nowrap"><span class="font-bold">HSL:</span> {{ colles[mostra].color_hsl[0] }}, {{ colles[mostra].color_hsl[1] }}%, {{ colles[mostra].color_hsl[2] }}%</li>
                        <li class="flex-nowrap"><span class="font-bold">CMYK:</span></li>
                    </ul>
                    </div>
                </div>

                

            </div>
            <div class="max-w-screen-lg md:mx-auto flex p-2 gap-2 flex-wrap"
     style="touch-action: manipulation; -webkit-overflow-scrolling: touch;"
      :style="{color:'hsl('+colles[mostra].color_hsl[0]+','+colles[mostra].color_hsl[1]+'%,40%)'}">
                <a href="#resum" role="button" class="flex-none bg-white rounded-sm font-bold p-2 hover:underline hover:bg-red-100">Resum</a>

                <a href="#assoliments" role="button" class="flex-none bg-white rounded-sm font-bold p-2 hover:underline hover:bg-red-100">Assoliments</a>

                <a href="#galeria" role="button"  class="flex-none bg-white rounded-sm font-bold p-2 hover:underline hover:bg-red-100">Galeria</a>

                <a href="#ubicacio" role="button" class="flex-none bg-white rounded-sm font-bold p-2 hover:underline hover:bg-red-100">Ubicació</a>

                <a href="#relacions" role="button"  class="flex-none bg-white rounded-sm font-bold p-2 hover:underline hover:bg-red-100">Relacions</a>

                <a href="#estadistiques" role="button"  class="flex-none bg-white rounded-sm font-bold p-2 hover:underline hover:bg-red-100">Estadístiques</a>
            </div>
        </div>
        
        <div class="max-w-screen-lg md:mx-auto p-2 flex flex-wrap gap-4">
            <div class="bg-white drop-shadow rounded-sm p-2 w-full ">
                <h2 id="resum" class="text-xl font-bold scroll-mt-20">Evolució:</h2>
                <div class="font-bold justify-between inline-flex w-full">
                        <label class="text-center text-xs">{{ fundacio_original }}</label>
                        <label class="text-center text-xs">{{actualitat}}</label>
                    </div>
                <Timeline :tippy=false :colla="colla" :origen="fundacio_original" @seleccio="seleccionaTimline"/>
            </div>
            <div class="flex flex-col md:flex-row gap-4 w-full">
            <div class="flex flex-col gap-4 w-full md:w-2/3">
                <div class="bg-white drop-shadow rounded-sm p-2 flex flex-col gap-2">
                    <h2 class="text-xl font-bold">Sobre la Colla <span class="text-base font-normal">(de <a href="https://ca.wikipedia.org" class="underline">Viquipèdia <font-awesome-icon :icon="['fab', 'wikipedia-w']" /></a>)</span></h2>
                    <ArticleWikipedia :key="colla.id" :obj="colla"/>
                </div>
            <template v-if="perfil">
                <div v-if="perfil?.notes" class="bg-white drop-shadow rounded-sm p-2 w-full">
                    <h2 class="text-xl font-bold">Notes:</h2>
                <p v-html="perfil.notes"></p>
                </div>
                <div class="bg-white drop-shadow rounded-sm p-2 gap-6 flex flex-col">
                    <p class="hidden text-center text-lg"><font-awesome-icon :icon="['fas', 'triangle-exclamation']" class="mr-2 text-red-600"/>Secció en procés d'implementació.<font-awesome-icon :icon="['fas', 'triangle-exclamation']"  class="ml-2 text-red-600"/></p>
                
                    <h2 id="assoliments" class="text-xl font-bold scroll-mt-20">Assoliments</h2>
                    <div v-if="colla.tipus=='universitaria'&&(colla.estat=='activa'||colla.estat=='formacio')" class="flex flex-col gap-1"><h3 class="text-base font-bold">Temporada actual <span class="font-normal bg-red-600 rounded px-1 text-white">2025-2026</span>: <span class="opacity-50 font-bold">(3C+P)</span></h3>
                        <TresConPiSigac :colla="colla.id"/>
                        </div>
                    <div v-if="perfil?.top_castells?.length" class="flex flex-col gap-2"><h3 class="text-base font-bold">Majors fites castelleres:</h3>
                        <div v-if="colla.tipus=='universitaria'&&(colla.estat=='activa'||colla.estat=='formacio')" class="flex flex-wrap gap-1">
                            <EtiquetaCastell v-for="castell in perfil?.top_castells" :key="castell" :castell="castell" :universitaria="colla.tipus=='universitaria'?true:false" />
                        </div>
                        <div v-else class="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-2">
                            <MiniaturaCastell v-for="castell in perfil?.top_castells" :key="castell" :castell="castell" :universitaria="colla.tipus=='universitaria'?true:false" />
                        </div>
                
                        <!--<div class="grid grid-cols-3 md:grid-cols-4 gap-2">
                         <div v-for="index in 6" :key="index" class="border border-gray-200 hover:bg-gray-200 active:border-red-600 border-2 rounded flex flex-col items-center">
                            <div class="flex w-full p-2 items-end">
                            <div class="w-9/12 border border-black aspect-square"></div><div class="grow border border-black"></div>
                        </div>
                            <span class="font-bold">test</span>
                            <div class="w-full bg-black h-4 text-white justify-center flex items-center text-sm pb-1 rounded-sm">★★★★</div>
                        </div>
                        </div> -->
                
                    </div>
                
                <div v-else class="w-full h-32 flex justify-center items-center flex-col">
                    <img src="@/assets/Mosaic-Logo-SF-Mini.png" alt="Logotip Mosaic" class="w-10 mt-1 mb-2 brightness-0 opacity-30" >
                
                    <h3 class="text-gray-400 text-lg">Colla sense registre de castells.</h3>
                </div>
                <div v-if="perfil?.top_castells?.length" class="text-gray-600 text-sm"><p>Dificultats segons la
                        <a v-if="colla.tipus!=='universitaria'"  class="text-red-600 hover:text-red-400 hover:underline"
                        href="https://gammaestrella.blogspot.com/p/cataleg.html" >taula de gamma del Baròmetre</a>
                        <a v-else-if="colla.tipus=='universitaria'"  class="text-red-600 hover:text-red-400 hover:underline"
                        href="https://sigac.cat/puntuacions" >taula de gamma Universitària</a>
                
                        </p>
                    </div>
                    </div>
            </template>
            <div class="bg-white drop-shadow rounded-sm p-2">

            <h2 id="galeria" class="text-xl font-bold scroll-mt-20">Galeria:</h2>
            
            <TiraGaleria v-if="galeria?.length"  class="h-[50vh] md:h-[25vh]" :array="galeria"/>
            <div v-else class="w-full flex justify-center items-center flex-col py-6">
            <img src="@/assets/Mosaic-Logo-SF-Mini.png" alt="Logotip Mosaic" class="w-10 mt-1 mb-2 brightness-0 opacity-30" >
        
            <h3 class="text-gray-400 text-lg">Encara no hi ha fotografies.</h3>
            </div>
            </div>
            </div>
            <div class="flex flex-col gap-4 w-full md:w-1/3">
                <div  v-if="ubicacio" class="bg-white drop-shadow rounded-sm p-2 flex flex-col gap-2">
                    <h2 id="ubicacio" class="text-xl font-bold scroll-mt-20">Ubicació:</h2>
                    <p  v-if="ubicacio.adreça"><strong>Adreça: </strong>{{ ubicacio.adreça }}</p>
                    <router-link :to="'/mapa'"><div id="map" :key="colla.id" class="w-full aspect-video md:aspect-square"></div></router-link>
                    <div class="w-full justify-center text-center text-sm flex"><p><strong>Lat: </strong>{{ ubicacio.coordenades[0] }}, <strong>Lng: </strong>{{ ubicacio.coordenades[1] }}</p></div>
                    <table class="">
                        <tr v-if="ubicacio.localitat" class="">
                            <td class="rounded-sm pb-1 text-right"> <div class="bg-gray-200 w-full px-1"><strong >Localitat:</strong></div></td>
                            <td class="px-1 w-full"> {{ ubicacio.localitat }}</td>
                        </tr>
                        <tr v-if="ubicacio.comarca" class="">
                            <td class="rounded-sm pb-1 text-right"> <div class="bg-gray-200 w-full px-1"><strong >Comarca:</strong></div></td>
                            <td class="px-1"> {{ ubicacio.comarca }}</td>
                        </tr>
                         <tr v-if="ubicacio.vegueria" class="">
                            <td class="rounded-sm pb-1 text-right"> <div class="bg-gray-200 w-full px-1"><strong >Vegueria:</strong></div></td>
                            <td class="px-1"> {{ ubicacio.vegueria }}</td>
                        </tr>
                        <tr v-if="ubicacio.provincia" class="">
                            <td class="rounded-sm pb-1 text-right"> <div class="bg-gray-200 w-full px-1"><strong>Província:</strong></div></td>
                            <td class="px-1"> {{ ubicacio.provincia }}</td>
                        </tr>
                        <tr v-if="ubicacio.autonomia" class="">
                            <td class="rounded-sm  pb-1 text-right"> <div class="bg-gray-200 w-full px-1"><strong>Autonomia:</strong></div></td>
                            <td class="px-1"> {{ ubicacio.autonomia }}</td>
                        </tr>
                        <tr v-if="ubicacio.pais && ubicacio.autonomia !== 'Catalunya'" class="">
                            <td class="rounded-sm pb-1 text-right"> <div class="bg-gray-200 w-full px-1"><strong>País:</strong></div></td>
                            <td class="px-1"> {{ ubicacio.pais }}</td>
                        </tr>

                    </table>
                </div>
                <div class="bg-white drop-shadow rounded-sm p-2 flex flex-col gap-2 z-[999]">
                    <h2 id="relacions" class="text-xl font-bold scroll-mt-20">Colles relacionades:</h2>
                    <h3 class="text-base font-bold" v-if="relacionsPerfil?.padrins?.length" >Padrins:</h3>
                    <div class="flex flex-col">
                        <SpanColla v-for="colla in relacionsPerfil?.padrins || []" :key="colla" :colla="colla"/>
                    </div>
                    <h3 class="text-base font-bold" v-if="relacionsPerfil?.fillols?.length" >Fillols:</h3>
                    <div class="flex flex-col">
                        <SpanColla v-for="colla in relacionsPerfil?.fillols || []" :key="colla" :colla="colla"/>
                    </div>
                    <h3 class="text-base " v-if="relacionsPerfil?.germans?.length" >Colles agermanades:</h3>
                    <div class="flex flex-col">
                            <SpanColla v-for="colla in relacionsPerfil?.germans || []" :key="colla" :colla="colla"/>
                    </div>
                    <h3 class="text-base font-bold" v-if="relacionsPerfil?.grups?.length">Part de:</h3>
                    <div class="flex flex-col">
                             <router-link :to="'/grups/' + grup" v-for="grup in relacionsPerfil?.grups || []" :key="grup" class="text-red-600 hover:text-red-400 hover:underline">
                                <img :src="require(`@/assets/grups/${grup}.svg`)" :alt="`Logotip del grup ${grup.nom}`" class="inline h-6"/>
                                {{ grups.find(g => g.id === grup)?.nom }}   
                             </router-link>
                    </div>
                </div>
            </div>
           
            </div>
             <div class="bg-white drop-shadow rounded-sm p-2 w-full">

            <h2 id="estadistiques" class="text-xl font-bold scroll-mt-20">Estadístiques:</h2>
            <div v-if="!perfil?.stats" class="w-full h-32 flex justify-center items-center flex-col">
            <img src="@/assets/Mosaic-Logo-SF-Mini.png" alt="Logotip Mosaic" class="w-10 mt-1 mb-2 brightness-0 opacity-30" >
        
            <h3 class="text-gray-400 text-lg">Sense registre.</h3>
            </div>
            <div v-else>
                <div class="flex flex-col gap-2 w-full">
                    <MiniCastellFila v-for="castell in perfil?.stats || []" :key="castell.castell" 
                    :castell="castell.castell" 
                    :data="castell.data" 
                    :lloc="castell.lloc"
                    :diada="castell.diada"
                    :universitaria="colla.tipus=='universitaria'?true:false" />   
                </div>
            </div>            
            </div>
        </div>
    </div>
 </template>

 <script setup>
 import { inject,computed,onMounted,ref,defineProps,watch } from 'vue'
//import MiniCastell from '@/components/MiniCastell.vue';

import { useRoute } from 'vue-router' 

import IcoTipEst from '@/components/IcoTipEst.vue';
import Timeline from '@/components/Timeline.vue';
import SpanColla from '@/components/SpanColla.vue';
import ArticleWikipedia from '@/components/ArticleWikipedia.vue';
import MiniCastellFila from '@/components/castells/FilaCastell.vue'; 
import Vimg from '@/components/Vimg.vue';
import TiraGaleria from '@/components/TiraGaleria.vue';
import TresConPiSigac from '@/components/TresConPiSigac.vue'; 

import escutDesconegut from '@/assets/escuts/escut_desconegut.svg'
import Perfils from '@/json/perfils.json'
import Relacions from '@/json/relacions.json'
import Ubicacions from '@/json/coordenades.json'
import Grups from '@/json/grups.json'
import Galeries from '@/json/galeries.json'

import Altres from '@/json/altres_colles.json'

import Format from '@/functions/formatTipEst.js'

import L from 'leaflet'

const actualitat=new Date().getFullYear()


// Props
const props = defineProps({
  id: String
})

const route = useRoute() // Access the current route
const dades = ref(null)
const Colles = inject('dades')

// Function to determine the list based on the route
function updateDades() {
  if (route.path.startsWith('/colles')) {
    dades.value = Colles
  } else if (route.path.startsWith('/altres')) {
    dades.value = Altres
  }
}

// Watch the route for changes and update the list dynamically
watch(() => route.path, updateDades, { immediate: true })

//const escutsSprite = inject('escutsSprite')
const colla = computed(() => {
    if (!Array.isArray(dades.value)) return null
    return dades.value.find(colla => colla.id === props.id) || null
})

const grups = ref(Grups)

const ubicacionsC = ref(Ubicacions)
const ubicacio = computed(() =>
ubicacionsC.value.find(colla => colla.id === props.id)
)

const perfilsColles = ref(Perfils)
const relacionsColles = ref(Relacions)

const perfil = computed(() => {
    if (!props.id) return null
    return perfilsColles.value.find(colla => colla.id === props.id) || null
})

const relacionsPerfil = computed(() => {
    if (!props.id) return null
    return relacionsColles.value.find(colla => colla.id === props.id) || null
})

watch(colla, (newColla) => {
    if (!newColla) return
    document.title = `${newColla.nom} - Mosaic Casteller`
    mostra.value = colles.value.length - 1
})

onMounted(()=>{
    if (colla.value) {
        document.title = `${colla.value.nom} - Mosaic Casteller`
    }
    
    if (ubicacio.value){
    const lat = ubicacio.value.coordenades[0]
    const lng = ubicacio.value.coordenades[1]
    const map = L.map('map',{
        zoomControl: false,       // disables +/- buttons
        dragging: false,          // disables dragging
        scrollWheelZoom: false,   // disables zooming with mouse wheel
        doubleClickZoom: false,   // disables zoom on double click
        boxZoom: false,           // disables zooming with selection box
        keyboard: false,          // disables keyboard controls
        touchZoom: false   
    }).setView([lat,lng],7)
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_2ret_1_017472a7324e3c81f1cb2896', {
    attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map)
    const TileIcon = (color)=>L.divIcon({
        html: `<div class="h-full w-full border border-2 border-white rounded-sm drop-shadow" 
        style="background-color:${color}"></div>`,
        iconSize: [30,30],
        iconAnchor: [15,15]
    })
    const marker = L.marker([lat, lng], { icon: TileIcon(colla.value.codi_color) })
    map.addLayer(marker)}

    
})
    let mostra = ref(0)
    const colles = computed(()=>{
        if (!colla.value) return []

        const muntat = []
        if (Array.isArray(colla.value.predecesores)){
            muntat.push(...colla.value.predecesores)
        }
        muntat.push(colla.value)
        return muntat
    })

        if (colles.value?.length) mostra.value=colles.value.length-1

    const fundacio_original =computed(() => {
        if (!colla.value) return null

        return Math.min(
            colla.value.fundacio,
            ...(colla.value.predecesores || []).map(c => c.fundacio)
        )
    })
    function seleccionaTimline(seleccio){
        mostra.value=seleccio
    }
    
function formatLlista(llista){
    if (llista === 'colles') return 'Colles Castelleres'
    if (llista === 'altres') return 'Altres Colles'
    return llista
}
const escut = computed(() =>{
  const actual = colles.value?.[mostra.value]
  if (!actual?.escut) return escutDesconegut

  try {
    return require(`@/assets/escuts/webp/${actual.escut}.webp`)
  } catch (err) {
    console.log('No s\'ha trobat l\'escut de la colla: '+actual.escut+'.webp')
    return escutDesconegut
  }
})

const galeria = computed(()=>{
    const found = Galeries.find(g => g.id === colla.value?.id)
    return found?.fotos || []
})

</script>

<style>

.tippy-box{
    border-radius:  0.25rem !important; 
    
}
.tippy-content{
    padding:0px !important;
}

</style>